import { Sparkles, Zap, FileText, Layers, Target, Shield, Globe, HelpCircle, MousePointer } from "lucide-react";

const MegoldasSection = () => {
  const features = [
    { title: "Hero (mit csinálsz + kinek + azonnali CTA)", icon: Sparkles },
    { title: "3–6 kiemelt előny (miért te)", icon: Zap },
    { title: "Szolgáltatások (érthetően, nem szakzsargonnal)", icon: FileText },
    { title: "Hogyan zajlik? (lépések, folyamat — csökkenti a bizonytalanságot)", icon: Layers },
    { title: "Átláthatóság / ár-elv (meglepetések nélkül)", icon: Target },
    { title: "Bizalom (valós, hiteles elemekkel)", icon: Shield },
    { title: "Terület / elérhetőség", icon: Globe },
    { title: "GYIK (kifogások előre kezelve)", icon: HelpCircle },
    { title: "Záró CTA (döntésre segít)", icon: MousePointer }
  ];

  return (
    <section id="megoldas" data-testid="megoldas-section" className="relative">
      {/* Dark header strip */}
      <div className="bg-ink py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="scroll-animate font-sora font-bold text-3xl sm:text-4xl lg:text-5xl text-on-dark leading-[1.15]">
            Nem egyszerű "honlapot" készítünk.{" "}
            <span className="text-gradient">Ügyfélszerző oldalt</span> építünk
          </h2>
          <p className="scroll-animate mt-6 text-on-dark/70 text-base sm:text-lg max-w-3xl mx-auto">
            A professzionális weboldal készítés lényege, hogy a látogató ne gondolkodjon sokáig.
            <br />
            Mi olyan felépítést adunk, ami szolgáltatóknál újra és újra beválik:
          </p>
        </div>
      </div>

      {/* Light feature grid */}
      <div className="light-band py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="scroll-animate-stagger scroll-animate grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {features.map((feature, i) => (
              <div
                key={i}
                className="card-light rounded-2xl p-6 flex items-start gap-4 hover:-translate-y-1 transition-transform"
              >
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <feature.icon size={20} className="text-primary" />
                </div>
                <p className="text-ink-text font-medium">{feature.title}</p>
              </div>
            ))}
          </div>

          <div className="scroll-animate mt-12 flex flex-wrap justify-center gap-3 text-center">
            <span className="px-5 py-2.5 rounded-full bg-primary/10 text-primary font-medium text-sm text-center">
              A cél: egy látogató se maradjon úgy, hogy "szép volt", de nem tudja, mit csináljon.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MegoldasSection;
